module.exports = __webpack_public_path__ + "img/FO.d2fff736.svg";